import { Injectable } from '@angular/core';
import { environment } from '../../../src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MaeUsuarioE,MaeUsuarioM,VersionM } from '../model/mae-usuario-bean';
import { Response_dml_bean,ResponseMensaje, MensajeServicioAD,MensajeServicioUtil } from '../model/response-dml';
import { AdminCredential,AdminCredentialUtil } from '../model/request_credenciales';

@Injectable({
  providedIn: 'root'
})
export class MaeUsuarioService {

  baseURL = environment.urlBase;
  userCons = environment.usuarioConstancias;
  passCons = environment.claveConstancias;
  //usuarioUtil = environment.apiUtilitario;
  constructor(private httpclient:HttpClient) {}

  proceDml(maeUsuarioE:MaeUsuarioE): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'usuario/api/procesodml';

    var body : string;
    body = JSON.stringify(maeUsuarioE);

    let headers = new HttpHeaders({
      'Content-Type' : 'application/json; charset=utf-8',
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.post<Response_dml_bean>(url,body,{headers});

  }
  insert(maeUsuarioE:MaeUsuarioE): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'usuario/api/insert';

    var body : string;
    body = JSON.stringify(maeUsuarioE);

    let headers = new HttpHeaders({
      'Content-Type' : 'application/json; charset=utf-8',
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.post<Response_dml_bean>(url,body,{headers});

  }
  update(maeUsuarioE:MaeUsuarioE): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'usuario/api/update';

    var body : string;
    body = JSON.stringify(maeUsuarioE);

    let headers = new HttpHeaders({
      'Content-Type' : 'application/json; charset=utf-8',
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.put<Response_dml_bean>(url,body,{headers});

  }

  get(P_CAMPO_PK: string): Observable<MaeUsuarioE[]> {

    var url  : string;
    url = this.baseURL + 'usuario/api/get';

    let params = new HttpParams()
    .set('P_CAMPO_PK', P_CAMPO_PK);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.get<MaeUsuarioE[]>(url, {headers:headers,params: params})

  }

  getfind(P_NOMBRES: string,P_C_OFICINA: string,P_X_ESTADO: string): Observable<MaeUsuarioM[]> {

    // P_C_OFICINA: string,P_NOMBRES: string,P_X_ESTADO: string
    var url  : string;
    url = this.baseURL + 'usuario/api/listar';

    let params = new HttpParams()
    .set('P_NOMBRES', P_NOMBRES)
    .set('P_C_OFICINA', P_C_OFICINA)
    .set('P_X_ESTADO', P_X_ESTADO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.get<MaeUsuarioM[]>(url,  {headers:headers,params: params});

  }

  getfindFirma(P_X_ESTADO: string): Observable<MaeUsuarioM[]> {

    // P_C_OFICINA: string,P_NOMBRES: string,P_X_ESTADO: string
    var url  : string;
    url = this.baseURL + 'usuario/api/listarfirmantes';

    let params = new HttpParams()
    .set('P_X_ESTADO', P_X_ESTADO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.get<MaeUsuarioM[]>(url,  {headers:headers,params: params});

  }

  getUser(P_X_USUARIO: string,P_ESID:string): Observable<MaeUsuarioE[]> {

    var url  : string;
    url = this.baseURL + 'usuario/api/getuser';
    //console.log(url);
    let params = new HttpParams()
    .set('P_X_USUARIO', P_X_USUARIO)
    .set('P_ESID', P_ESID);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.get<MaeUsuarioE[]>(url, {headers:headers,params: params})

  }

  getLoginUtil(adminCredential:AdminCredentialUtil): Observable<MensajeServicioUtil> {

    var url  : string;
    //url = this.baseURL + 'usuario/api/login';
    url = this.baseURL + 'usuario/api/loginDominio';
    //url = this.usuarioUtil+'api/usuario/login';

    var body : string;
    body = JSON.stringify(adminCredential);

    let headers = new HttpHeaders({
      'Content-Type' : 'application/json; charset=utf-8',
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.post<MensajeServicioUtil>(url,body,{headers});

  }


  getVersion(): Observable<VersionM> {

    var url  : string;
    url = this.baseURL + 'a_version/a_version';
    //console.log(url);

    return this.httpclient.get<VersionM>(url)

  }
}
